



























































import { Watch, Component } from 'vue-property-decorator';
import PickerBase from './base';
import query from '@/components/query/query-constructor';

@Component
export default class PagePicker extends PickerBase {
  currentPage: number | string = 1;

  get normalizedValue() {
    const { limit, offset } = this.$store.getters.tableQueryForCurrentTab;
    return Math.ceil(offset[this.currentReportType] / limit) + 1;
  }

  get isDisabledLeft() {
    if(!this.$store.getters.tableQueryForCurrentTab.limit) return true;
    return this.normalizedValue <= 1
  }

  get isDisabledRight() {
    if(!this.$store.getters.tableQueryForCurrentTab.limit) return true;
    return  this.normalizedValue === this.lastPageNumber
  }

  get lastPageNumber() {
    const { limit } = this.$store.getters.tableQueryForCurrentTab;
    const totalItems = this.$store.state.table.total;
    return Math.ceil(totalItems / limit) || 1;
  }

  setPageFromOffset() {
    const { limit = 1, offset } = this.$store.getters.tableQueryForCurrentTab;
    this.currentPage = Math.floor(offset[this.currentReportType] / limit) + 1;
  }

  setPage(blur: boolean = false) {
    let page = this.getFixedPage();
    if(page !== this.currentPage) {
      this.currentPage = page;
      this.setOffsetFromPage();
    }

    if(blur) {
      //@ts-ignore
      this.$refs.input.blur();
    }
  }

  getFixedPage() {
    let page = parseInt(this.currentPage as string);
    return Number.isNaN(page) || this.currentPage < 1
      ? 1
      : page > this.lastPageNumber
        ? this.lastPageNumber
        : page;
  };

  goToNext() {
    let page = this.getFixedPage();
    if (page < this.lastPageNumber) 
      this.currentPage = +page + 1;

    this.setOffsetFromPage();
  };

  goToPrev() {
    let page = this.getFixedPage();
    if (page > 1) 
      this.currentPage = +page - 1;
    
    this.setOffsetFromPage();
  };

  goToFirst() {
    this.currentPage = 1;
    this.setOffsetFromPage();
  };

  goToLast() {
    this.currentPage = this.lastPageNumber;
    this.setOffsetFromPage();
  };

  saveOffset({ value, isPushUrl }) {
    this.$store.commit('tableOffsetForCurrentTab', {
      groupBy:this.currentReportType,
      value: value
    })
    if(isPushUrl){
      this.pushURL()
    }
  }

  setOffsetFromPage(val: any = this.currentPage) {
    const newOffset = (val - 1) * (this.$store.getters.tableQueryForCurrentTab.limit || 0);
    this.saveOffset({
      value: newOffset,
      isPushUrl: true
    })
  }

  @Watch('$store.state.table.total')
  totalChange() {
    if (this.currentPage > this.lastPageNumber) {
      this.currentPage = this.lastPageNumber
      this.setOffsetFromPage()
    }
  }

  resetPage() {
    this.currentPage = 1
    this.setOffsetFromPage()
  }

  onBusApplyFilters() {
    this.resetPage();
  }

  onBusResetOffset() {
    this.resetPage();
  }

  mounted() {
    this.bus.on('reset-pagination', this.resetPage);
    this.bus.on('apply-filters', this.onBusApplyFilters);
    this.bus.on('reset-offset', this.onBusResetOffset);
    this.bus.on('report-tab-added', this.onBusReportTabAdded);
    this.bus.on('report-tab-updated', this.onBusReportTabUpdated);
    if(!this.isReport()){
      if(this.$store.getters.tableQueryForCurrentTab?.offset?.[this.currentReportType]){
        this.applyDataFromStore()
      }else{
        this.applyDataFromUrl()
      }
    }
  }

  beforeDestroy() {
    this.bus.off('reset-pagination', this.resetPage);
    this.bus.off('apply-filters', this.onBusApplyFilters);
    this.bus.on('reset-offset', this.onBusResetOffset);
    this.bus.off('report-tab-added', this.onBusReportTabAdded);
    this.bus.off('report-tab-updated', this.onBusReportTabUpdated);
  }

  onBusReportTabAdded() {
    // take data from url on active report page
    if(this.isReport()){
      if(this.$store.getters.tableQueryForCurrentTab?.offset?.[this.currentReportType]){
        this.applyDataFromStore()
      }else{
        this.applyDataFromUrl()
      }
    }
  }

  onBusReportTabUpdated() {
    if(!this.$store.getters.tableQueryForCurrentTab.offset[this.currentReportType]){
      this.saveOffset({
        value: 0,
        isPushUrl: true
      })
    }
    this.applyDataFromStore()
  }

  applyDataFromStore() {
    this.setPageFromOffset();
  }

  applyDataFromUrl() {
    const routeParams = query.decode(this.$route.params.data as string);
    const { offset } = routeParams;
    this.saveOffset({
      value: offset ? +offset : 0,
      isPushUrl: false
    })
    this.setPageFromOffset();
  }
}
